import { DetailedPlayerType } from "@/pages/DetailedPlayer/DetailedPlayer";

import axios from "../../apiFc24";

export const getPlayer = async ({
  resourceId,
  playerRoleId,
  evoPathId,
  evolutionPath,
  expanded = false,
}: {
  resourceId: number;
  playerRoleId?: number;
  evoPathId?: number;
  evolutionPath?: number[];
  expanded?: boolean;
}) => {
  const params = new URLSearchParams({
    ...(playerRoleId ? { "player-role-id": playerRoleId.toString() } : {}),
    ...(evoPathId ? { evoPathId: evoPathId.toString() } : {}),
    ...(evolutionPath ? { evolutionPath: evolutionPath.join("-") } : {}),
  });

  // Build the URL properly, only adding ? if there are params
  let url = `/players/${resourceId}`;
  const queryString = params.toString();

  if (queryString) {
    url += `?${queryString}`;
    if (expanded) url += "&expanded=true";
  } else if (expanded) {
    url += "?expanded=true";
  }

  const res = await axios.get<DetailedPlayerType>(url);
  return res.data;
};
